import composeOperator from 'fc-operations'

export const operator = composeOperator({
  model: 'jobRecord',
  branch: 'tableOperation',
})

export default operator
